<div class="favicon-wrapper">
  <img class="site-favicon"
       id="brand-logo"
       src="https://cdn.brandfetch.io/{{domain}}/icon/theme/light/fallback/lettermark/w/400/h/400?c=1id2VkQaamM4pwWDS48"
       (error)="onImgError($event)"
  >
</div>
